var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.998 6.24875C12.4162 6.24875 6.24805 12.4169 6.24805 19.9987C6.24805 27.5806 12.4162 33.7487 19.998 33.7487C27.5799 33.7487 33.748 27.5806 33.748 19.9987C33.748 12.4169 27.5799 6.24875 19.998 6.24875Z",
    fill: "url(#paint0_linear_1072_427)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 0C1.68187 0 0 1.68187 0 3.75C0 5.81812 1.68187 7.5 3.75 7.5C5.81812 7.5 7.5 5.81812 7.5 3.75C7.5 1.68187 5.81812 0 3.75 0Z",
    fill: "url(#paint1_linear_1072_427)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 32.5C34.1819 32.5 32.5 34.1819 32.5 36.25C32.5 38.3181 34.1819 40 36.25 40C38.3181 40 40 38.3181 40 36.25C40 34.1819 38.3181 32.5 36.25 32.5Z",
    fill: "url(#paint2_linear_1072_427)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1336 2.86624C33.9067 -0.36188 26.5054 4.12375 22.9923 6.58062C24.0267 6.81124 25.0192 7.15562 25.9517 7.60562C30.9067 4.42062 34.3761 3.64562 35.3661 4.63374C36.0204 5.28812 36.0348 7.46874 33.9217 11.4606C31.8529 15.3675 28.3711 19.8619 24.1167 24.1169C14.7379 33.4962 6.31481 37.0437 4.63356 35.3662C3.64543 34.3775 4.42043 30.9075 7.60543 25.9519C7.15543 25.0194 6.81106 24.0269 6.58043 22.9931C4.12481 26.5062 -0.359568 33.9069 2.86606 37.1337C3.64356 37.9112 4.69481 38.265 5.94856 38.265C10.9254 38.265 19.0836 32.6862 25.8842 25.8844C30.3104 21.4587 33.9498 16.7512 36.1317 12.63C38.5692 8.02437 38.9161 4.64812 37.1336 2.86624Z",
    fill: "url(#paint3_linear_1072_427)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 20C10.56 20 10 19.44 10 18.75C10 13.925 13.925 10 18.75 10C19.44 10 20 10.56 20 11.25C20 11.94 19.44 12.5 18.75 12.5C15.3038 12.5 12.5 15.3038 12.5 18.75C12.5 19.44 11.94 20 11.25 20ZM24.6325 13.3825C24.87 13.1513 25.0012 12.8256 25.0012 12.5013C25.0012 12.17 24.87 11.8512 24.6325 11.62C24.1762 11.1575 23.3325 11.1512 22.8638 11.62C22.6325 11.8512 22.5012 12.1763 22.5012 12.5013C22.5012 12.8263 22.6325 13.1513 22.87 13.3888C23.1012 13.62 23.4262 13.7513 23.7512 13.7513C24.0756 13.7513 24.4012 13.62 24.6325 13.3825Z",
    fill: "url(#paint4_linear_1072_427)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1072_427",
    x1: 10.2799,
    y1: 29.7169,
    x2: 29.7162,
    y2: 10.2806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1072_427",
    x1: 1.1,
    y1: 6.40125,
    x2: 6.40063,
    y2: 1.10062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1072_427",
    x1: 33.6,
    y1: 38.9012,
    x2: 38.9006,
    y2: 33.6006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7055C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D055C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1072_427",
    x1: 3.20168,
    y1: 37.4694,
    x2: 37.4692,
    y2: 3.20187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1072_427",
    x1: 11.1531,
    y1: 20.4206,
    x2: 22.2931,
    y2: 9.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADF9B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanet);
export default __webpack_public_path__ + "static/media/planet.98b15665fdda87b6f0bf071e576af32d.svg";
export { ForwardRef as ReactComponent };